import { appDimensions } from "config/app-constants";
import { createRef, ReactNode } from "react";
import { TableFooterTableConfig } from "types/datalist-types";
import CoreComponent from "utilities/component-utilities/CoreComponent";
import { resolveBottomClassName } from "utilities/datalist/datalist-utilities";

type DatalistStickyFooterPropsType = {
    name: string;
    config?: TableFooterTableConfig
}

class DatalistStickyFooter extends CoreComponent<DatalistStickyFooterPropsType> {
    private tableWrapperElement: HTMLDivElement | undefined;
    private mainElement: HTMLElement | undefined;
    private footerRef = createRef<HTMLDivElement>();
    private footerElement: HTMLElement | undefined;
    private stickyFooterElement: HTMLDivElement | undefined;
    private stickyFooterInnerElement: HTMLDivElement | undefined;
    private tableHeaderElement: HTMLElement | undefined;
    private top: number = 0;
    private bottom: number = 0;

    componentDidMount() {
        super.componentDidMount();
        if (this.props.config?.columns.length) {
            this.initElements();
            this.mainElement?.addEventListener('scroll', this.onScroll);
            this.tableWrapperElement?.addEventListener('scroll', this.onScroll);
            window.addEventListener('resize', this.dimensions);
        }
    }

    componentDidUpdate() {
        if (this.props.config?.columns.length) {
            this.dimensions();
        }
    }

    componentWillUnmount(): void {
        super.componentWillUnmount();
        this.mainElement?.removeEventListener('scroll', this.onScroll);
        this.tableWrapperElement?.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.dimensions);
    }

    private initElements = () => {
        this.mainElement = document.getElementsByTagName('main')[0];
        this.tableWrapperElement = this.footerRef.current!.parentElement as HTMLDivElement;
        this.tableHeaderElement = this.tableWrapperElement.getElementsByTagName('thead')[0] as HTMLTableSectionElement;
        this.footerElement = this.tableWrapperElement.getElementsByTagName('tfoot')[0] as HTMLTableSectionElement;
        this.stickyFooterElement = this.footerRef.current!;
        this.stickyFooterInnerElement = this.stickyFooterElement.children[0] as HTMLDivElement;
        this.dimensions();
    }

    private dimensions = () => {
        if (!this.mainElement) return;
        this.top = this.mainElement!.scrollTop + this.tableHeaderElement!.getBoundingClientRect().bottom + appDimensions.appHeaderHeight + this.tableHeaderElement!.offsetHeight;
        const left = this.tableWrapperElement!.scrollLeft + this.footerElement!.getBoundingClientRect().left;
        this.bottom = this.mainElement!.scrollTop + this.footerElement!.getBoundingClientRect().top + this.footerElement!.offsetHeight;
        // #region set dimensions for wrapper
        this.stickyFooterElement!.style.width = `${this.tableWrapperElement?.offsetWidth}px`;
        this.stickyFooterElement!.style.left = `${left}px`;
        // #endregion 

        this.stickyFooterInnerElement!.style.width = `${this.footerElement!.offsetWidth}px`;
        this.stickyFooterInnerElement!.style.height = `${this.footerElement!.offsetHeight}px`;
        this.stickyFooterInnerElement?.childNodes.forEach((childNode: ChildNode, index: number) => {
            const childElement = childNode as HTMLElement;
            const footerElement = this.footerElement?.children[0].childNodes[index] as HTMLElement;
            childElement.style.width = `${footerElement.offsetWidth}px`;
        });
        this.onScroll();
    }

    private onScroll = () => {
        this.stickyFooterElement!.scrollLeft = this.tableWrapperElement!.scrollLeft;
        const scrollTop = this.mainElement!.scrollTop + window.innerHeight;
        if (scrollTop >= this.top && scrollTop <= this.bottom) {
            this.stickyFooterElement!.classList.remove('hidden');
        } else {
            this.stickyFooterElement!.classList.add('hidden');
        }
    }

    render(): ReactNode {
        if (!this.props.config?.columns?.length) return <></>;
        let className = resolveBottomClassName(this.props.config, 'sticky-header-footer hidden sticky-footer');

        return (
            <div ref={this.footerRef} className={className}>
                <div className="column-wrapper flex">
                    {this.props.config.columns.map(f => {
                        return (
                            <div key={`datalist-${this.props.name}-footer-sticky-${f.name}`}
                                className={`${f.className} theme-bg table-column`}
                            >
                                {f.value}
                            </div>
                        )
                    })}
                </div>
            </div>
        );
    }

};

export default DatalistStickyFooter;
